<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container v-if="showBubble">
      <Bubble v-if="preOrder == true" :content="bubbleContent" />
      <OrderDetailBubble
        v-else-if="preOrder == false && order"
        :order="order"
      />
    </v-container>

    <!-- メニュー一覧 -->
    <v-container v-if="showMenuContents && order">
      <OrderDetail :mode="1" :order="order" :showReOrder="false" />
    </v-container>

    <v-container v-if="showButtonArea">
      <v-row v-if="preOrder == true && order">
        <v-col>
          <v-btn x-large block tile text outlined @click="changeCart"
            >注文を修正する</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <v-btn x-large text @click="close">
            <span class="text-decoration-underline">トーク画面へもどる</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- sheet エラー(トーク画面へもどる) -->
    <v-bottom-sheet v-model="showErrorCmnSheet" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question=""
                :content="errorSheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="close"
              ><span class="text-decoration-underline white--text"
                >トーク画面へもどる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(カート移動) -->
    <v-bottom-sheet v-model="showSheetCart" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble :content="errorSheetCartText" :border-content="false" />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="カートを表示する"
              class="ma-2"
              :click="onClickToCart"
            />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { liffReady, closeWindow } from "../util/liff_util";
import OrderDetailBubble from "./parts/OrderDetailBubble";
import OrderDetail from "./parts/OrderDetail";
import Bubble from "./parts/Bubble";
import QuickReply from "./parts/QuickReply";
import { createCheckErrMsg } from "../util/order_util";

export default {
  name: "Order",
  components: {
    OrderDetailBubble,
    OrderDetail,
    Bubble,
    QuickReply,
  },
  props: {},
  data: () => ({
    bubbleContent: "",
    preOrder: true, // 仮注文
    cartMenus: [], // 現在のカート内のメニュー
    // 表示制御
    showBubble: false,
    showMenuContents: false,
    showButtonArea: false,
    //
    showErrorCmnSheet: false,
    errorSheetCmnText: "",
    showSheetCart: false,
    errorSheetCartText: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "注文情報";
  },
  async mounted() {
    await liffReady(); // LIFF 初期化待機
    this.showProgress();

    try {
      // カートID(クエリ)
      const queryCartId = this.$route.query.cartId;
      console.log("cartId(query)", queryCartId);
      if (!queryCartId) {
        // URL 直指定 (ありえない)
        console.log("### not implemented (cartId なし)");
        return;
      }

      // トーク画面からの遷移
      await this.bindDataFromTalk(queryCartId);
    } catch (e) {
      console.error(e);
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress", "order"]),
  },
  watch: {
    order: function () {
      if (!this.order) {
        return;
      }
      // ページ内コンテンツ
      this.showBubble = true;
      this.showMenuContents = true;
      this.showButtonArea = true;
    },
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "isOrderPassed",
      "fetchHistoryOrderByCartId",
      "checkBeforeInitNotPassed",
      "fetchTempOrderData",
      "deleteCartMenusPhysically",
    ]),
    ...mapActions("rest", ["checkItemsInCart"]),
    bindDataFromTalk: async function (queryCartId) {
      console.log(`#from Talk: ${queryCartId}`);

      // 「お店に注文が通っているか」 (users/xxx/orders に存在するか)
      // 通っている: 該当の 注文情報 表示
      // 通ってない:
      //   チェックOK:「注文確定してません」 + 現在のカート内容表示
      //   チェックNG:「カートメニューが変更されました～」
      const passed = await this.isOrderPassed({ queryCartId });
      if (passed) {
        await this.bindPassedProcess(queryCartId);
        this.preOrder = false;
      } else {
        await this.bindNotPassedProcess(queryCartId);
        this.preOrder = true;
      }
    },
    bindPassedProcess: async function (queryCartId) {
      // 注文情報 表示
      return this.fetchHistoryOrderByCartId({ queryCartId });
    },
    bindNotPassedProcess: async function (queryCartId) {
      // 事前チェック
      const checkResult = await this.checkBeforeInitNotPassed({ queryCartId });
      if (!checkResult.result) {
        const checkType = checkResult.type;
        const msg = createCheckErrMsg(checkType);
        this.showSheetCart = true;
        this.errorSheetCartText = msg;
        return;
      }

      // 仮注文データ取得
      await this.fetchTempOrderData();

      // 仮注文データ表示 (現在のカート内容そのまま)
      const content = "注文はまだ確定していません。";
      this.bubbleContent = content;
    },
    changeCart: function () {
      // 画面遷移(カート)
      this.$router.push({ name: "Cart" });
    },
    onClickToCart: async function () {
      // カート内アイテム 物理削除 (論理削除のメニューのみ)
      await this.deleteCartMenusPhysically();

      // 画面遷移 (カート)
      this.$router.push({ name: "Cart" });
    },
    close: function () {
      // LIFF 閉じる
      closeWindow();
    },
  },
};
</script>
